import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import FaqInterface, {
  FaqItemInterface,
} from 'common/types/entities/FaqInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createFaq(
  parentId: string,
  masterBlockId?: MasterBlockId,
): FaqInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.Faq,
    childIds: [],
    parentId: parentId,
    masterBlockId: masterBlockId,
    showIcons: true,
    mobileShowIcons: true,
    iconClassName: 'fas fa-chevron-circle-up',
    iconColor: 'rgba(24, 24, 24, 1)',
    backgroundColor: 'rgba(241, 244, 248, 1)',
    titleColor: 'rgba(24, 24, 24, 1)',
    titleFontSize: 16,
    spaceBetweenItems: 10,
    itemBorderRadius: 5,
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    itemPadding: {
      paddingTop: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingLeft: 20,
    },
    mobileItemPadding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 15,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {},
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.Faq),
  }
}

export function createFaqAnswer(
  parentId: string,
  masterBlockId?: MasterBlockId,
  creationItemNumber = 1,
): FaqItemInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.FaqItem,
    creationItemNumber: creationItemNumber,
    title: '',
    parentId: parentId,
    masterBlockId: masterBlockId,
    childIds: [],
  }
}
